import { Box, Table } from '@factorialco/deprecated-design-system'
import { EmployeeCustomTablesSchemaFragment } from 'generated/resources/graphql'
import isEmpty from 'lodash/isEmpty'

import { observer } from 'mobx-react'

import createComputed from 'modules/core/hooks/createComputed'
import useSearch from 'modules/core/hooks/useSearch'

import type Value from 'modules/custom_resources/store/models/customResources/Value'
import Options from 'modules/employees/components/CustomTables/List/_List/_CustomTable/_Options'
import TableBody from 'modules/employees/components/CustomTables/List/_List/_CustomTable/_TableBody'
import TableHeader from 'modules/employees/components/CustomTables/List/_List/_CustomTable/_TableHeader'

const useFilteredValues = createComputed((search, values) => {
  if (!values || isEmpty(search)) return values

  return values?.filter((value: Value) => value.matchCustomFieldValue(search))
})
interface Props {
  canManage: boolean
  canAddValues: boolean
  attachableId: number
  schema: EmployeeCustomTablesSchemaFragment
  values?: Value[]
  currency: string
}

const TableComponent = ({
  attachableId,
  schema,
  values,
  canManage,
  canAddValues,
  currency,
}: Props) => {
  const { search, onSearch } = useSearch()
  const filteredValues = useFilteredValues(search, values).get()

  const TableOptions = () => (
    <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center" gap="s24" flexGrow>
      <Options
        schemaId={schema.id.toString()}
        search={search}
        onSearch={onSearch}
        canAddValues={canAddValues}
        canManage={canManage}
      />
    </Box>
  )

  const fieldLabels: string[] = schema.fields.map((f) => f.field?.labelText).filter(Boolean)

  return (
    <Box overflowX="scroll">
      <Table options={TableOptions} style={{ minWidth: '100%', width: 'min-content' }} autoLayout>
        <TableHeader fieldsLabels={fieldLabels} />
        <TableBody
          attachableId={attachableId}
          schema={schema}
          values={filteredValues}
          currency={currency}
        />
      </Table>
    </Box>
  )
}

export default observer(TableComponent)
